
import HttpService from './HttpService'
import ConstDef from '../ConstDef'
import ParamModel from '../domain/ParamModel'
import UserInfoModel from '../domain/UserInfoModel'
import JsEncrypt from 'jsencrypt/bin/jsencrypt'
import AesCrypto from './AesCrypto'

export default class LoginByUserIdAndPasswdProc {
  static SendParamModel (userId, passwd, aesKey, aesIv, rsaKey, fnRsaEnc) {
    let jsonObject = {
      'proc': 'spLoginByUserIdAndPasswd',
      'ps': {
        'aesKey': aesKey,
        'userId': userId,
        'passwd': passwd,
        'aesIv': aesIv
      }
    }
    let plainText = JSON.stringify(jsonObject) // '{"version":"20180509.1","userId":"U00488","password":"eluonlbs","session":"nx49ea2hmv","forceCont":true,"receiver":true}'
    let encode = fnRsaEnc(plainText, rsaKey.publicKeyModulus, rsaKey.publicKeyExponent)
    let param = new ParamModel()
    param.command = ConstDef.CONNECT
    param.body = encode
    return HttpService.login(param)
  }
  static SendParamModelNoExponent (userId, passwd, aesKey, aesIv, rsaKey) {
    let encrypt = new JsEncrypt()
    encrypt.setPublicKey(rsaKey.publicKey)

    let jsonObject = {
      'proc': 'spLoginByUserIdAndPasswd',
      'ps': {
        'aesKey': aesKey,
        'userId': encrypt.encrypt(userId),
        'passwd': encrypt.encrypt(passwd),
        'aesIv': aesIv
      }
    }
    let plainText = JSON.stringify(jsonObject) // '{"version":"20180509.1","userId":"U00488","password":"eluonlbs","session":"nx49ea2hmv","forceCont":true,"receiver":true}'
    let param = new ParamModel()
    param.command = ConstDef.CONNECT
    param.body = plainText
    return HttpService.loginNoExponent(param)
  }
  static SendParamModelToken (token) {
    console.log(token)
    let jsonObject = {
      'proc': 'spFindAllUserToken',
      'ps': {
        'token': token
      }
    }
    let plainText = JSON.stringify(jsonObject)
    let encode = AesCrypto.GetEncryptString(plainText)
    let param = new ParamModel()
    param.command = this.EXEC_PROC
    param.body = encode
    return HttpService.loginJwt(param)
  }

  static MakeModel (data) {
    let json = JSON.parse(data.body)
    let userInfo = new UserInfoModel()
    userInfo.authResult = json.authResult
    userInfo.passwd = json.passwd
    userInfo.userId = json.userId
    userInfo.userName = json.userName
    userInfo.permission = json.permission
    userInfo.userImage = json.userImage
    userInfo.division = json.division
    userInfo.token = json.token
    console.log(userInfo)
    return userInfo
  }
}
